import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import HeaderEN from "../../headerEN/headeren";
import FooterEN from "../../footerEN/footer";
import './erpbasedsolutions.scss';

const ErpBasedSolutions = () => {

  useEffect(() => {
    const handleContextmenu = e => {
        e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        document.removeEventListener('contextmenu', handleContextmenu)
    }
  
  },[])

  const [tabsList, setTabsList] = useState([{ text: "Travel Insurance", url: "travel-insurance" }, { text: "Life Insurance", url: "life-insurance" }])
  const [tab, setTab] = useState(0)

  return (
    <div class="main-fluid">
      <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      <div class="dsk-tab-btn-viewmode-en">
        <div class="erpbasedsolu-tab-imagebannermain-en">
          <div class="erpbasedsolu-banner-con-en">
            <div class="erpbasedsolutab-banne-sec-en">
              <h1 class="erpbasedsolu-banner-heading-en">Customer Services</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "report-a-claim"}>Report a Claim</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "claim-consultancy-services"}>Claim Consultancy Services</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "service-excellence"}>Service Excellence</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "in-house-kr-automotive-garage"}>In house KR Automotive Garage</div>
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "erp-based-solutions"}>ERP Based Solutions</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="erpbasedsolu-banner-con-en">
          <div class="erpbasedsolu-bdy-en">
            {/* <h2 class="pagetitle-en">ERP Based Solutions</h2> */}
            <div class="erpbasedsolu-dflex-en">
              {/* LEFT SIDE IMAGE SECTION STARTS HERE */}
              <div class="erpbasedsolu-dlex-lft-en">
                <h2 class="pagetitle-en">ERP Based Solutions</h2>

                <p class="erpbasedsolu-pg-txt-con">KR Insurance Services works on industries best insurance ERP platform to facilitate :-</p>

                <div class="erpbasedsolu-keypoint-en">
                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Hassle free services to clients.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Digital documentations (Claim Forms, Proposal Forms, Policy Copies etc.)</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Maintaining data confidentiality.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Declarations - Marine & Policy Endorsements.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Quality checks - Proposed terms V/s Received Policy Terms.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Claims Intimation, Settlement process & Claim Status Updates.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Generating auto renewal reminders.</div>

                  <div class="erpbasedsolu-keypoint-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
                  <div class="erpbasedsolu-keypoint-item-en">Online Report generations.</div>
                </div>

                <h3 class="erpbasedsolu-whykrinsu-title-en">Why KR Insurance Services ?</h3>
                <div class="clearfix"></div>

                <div class="erpbasedsolu-pins-list-lftdksp-en">
                  <div class="erpbasedsolu-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
                  <div class="erpbasedsolu-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
                  <div class="erpbasedsolu-lt-one-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
                  <div class="erpbasedsolu-lt-two-lftdksp-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
                </div>
              </div>
              {/* LEFT SIDE IMAGE SECTION ENDS HERE */}
              {/* RIGHT SIDE IMAGE SECTION STARTS HERE */}
              <div class="erpbasedsolu-dlex-rgt-en">
                <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution.png"} alt="erp based solution" />
              </div>
              {/* RIGHT SIDE IMAGE SECTION ENDS HERE */}
            </div>
          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* TAB-VIEW AND TABS SECTION STARTS HERE */}
      <div className="tab-btn-viewmode-en">
        <div class="erpbasedsolu-tab-imagebannermain-en">
          <div class="erpbasedsolu-banner-con-en">
            <div class="erpbasedsolutab-banne-sec-en">
              <h1 class="erpbasedsolu-banner-heading-en">Customer Services</h1>
              {/* TAB BUTTON SECTION STARTS HERE */}
              <div class="grpacc-covinsu-tab-btn-en">
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "report-a-claim"}>Report a Claim</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "claim-consultancy-services"}>Claim Consultancy Services</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "service-excellence"}>Service Excellence</div>
                <div class="grpacc-insu-tab-btn-item-en" onClick={() => window.location.href = "in-house-kr-automotive-garage"}>In house KR Automotive Garage</div>
                <div class="grpacc-insu-tab-btn-item-active-en" onClick={() => window.location.href = "erp-based-solutions"}>ERP Based Solutions</div>
              </div>
              {/* TAB BUTTON SECTION ENDS HERE */}
            </div>
          </div>
        </div>
        <div class="erpbasedsolu-banner-con-en">
          <div className="tab-imgtxt-en">
            <h2>ERP Based Solutions</h2>
            <div className="tabs-cont-en">
              <img className="rgt-img-en" src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution.png"} alt="erp based solution" />
              <p>KR Insurance Services works on industries best insurance ERP platform to facilitate :-</p>

              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Hassle free services to clients.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Digital documentations (Claim Forms, Proposal Forms, Policy Copies etc.)</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Maintaining data confidentiality.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Declarations - Marine & Policy Endorsements.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Quality checks - Proposed terms V/s Received Policy Terms.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Claims Intimation, Settlement process & Claim Status Updates.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Generating auto renewal reminders.</p>
              <p className="txtimg"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Online Report generations.</p>

              <h3 class="tab-whykrinsu-title-en">Why KR Insurance Services ?</h3>

              <div class="tab-whykrinsu-pins-list-en">
                <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Competitive Terms</div>
                <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Prompt Claim Services</div>
                <div class="tab-whykrinsu-pinlft-one-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Wide Quote Comparisons</div>
                <div class="tab-whykrinsu-pinlft-two-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="sheild" /> Best Insurance Industry Practices</div>
              </div>

            </div>
          </div>

        </div>
      </div>
      {/* TAB-VIEW AND TABS SECTION ENDS HERE */}

      {/* MOBILE PAGE STARTS HERE */}
      <div class="erpbasedsolu-tab-imagebannermain-en hidden-desktop hidden-md-device hidden-lg">
        <div class="dropdown-sec">
          <select class="form-select" onChange={(e) => window.location.href = e.target.value}>
            <option value={"claim-consultancy-services"}>Claim Consultancy Services</option>
            <option value={"service-excellence"}>Service Excellence</option>
            <option value={"in-house-kr-automotive-garage"}>In house KR Automotive Garage</option>
            <option value={"erp-based-solutions"} selected class="active">ERP Based Solutions</option>
          </select>
        </div>
        <div class="erpbasedsolu-mob-main-en">
          <h1 class="erpbasedsolu-banner-heading-en">ERP Based Solutions</h1>
          <div class="erpbasedsolu-mob-img-en">
            <img src={process.env.PUBLIC_URL + "/customer_service/tab_images/erp_based_solution.png"} alt="erp based solution" />
          </div>

          <p class="erpbasedsolu-mob-txt-en">KR Insurance Services works on industries best insurance ERP platform to facilitate :-</p>

          <div class="erpbasedsolu-pins-list-mob-en">
            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Hassle free services to clients.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Digital documentations (Claim Forms, Proposal Forms, Policy Copies etc.)</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Maintaining data confidentiality.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Declarations - Marine & Policy Endorsements.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Quality checks - Proposed terms V/s Received Policy Terms.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Claims Intimation, Settlement process & Claim Status Updates.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Generating auto renewal reminders.</div>

            <div class="erpbasedsolu-pins-list-mob-itemimg-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /></div>
            <div class="erpbasedsolu-pins-list-mob-item-en">Online Report generations.</div>
          </div>

          <h3 class="erpbasedsolu-whykrinsu-mob-title-en">Why KR Insurance Services ?</h3>

          <div class="erpbasedsolu-mob-whykrlist-en">
            <div class="erpbasedsolu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Competitive Terms</div>
            <div class="erpbasedsolu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Prompt Claim Services</div>
            <div class="erpbasedsolu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Wide Quote Comparisons</div>
            <div class="erpbasedsolu-mob-whykrlist-item-en"><img src={process.env.PUBLIC_URL + "/personalinsurance_images/shield.svg"} alt="shield" /> Best Insurance Industry Practices</div>
          </div>
        </div>
      </div>
      {/* MOBILE PAGE ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default ErpBasedSolutions;
